export function mergeActiveScenarios(scenarios) {
  const active = (scenarios || []).filter(s => s.active)
  return {
    id: null,
    actions: active.flatMap(s => s.actions || []),
    campaign_scenario_action_groups: active.flatMap(s => s.campaign_scenario_action_groups || []),
    campaign_scenarios_project_assets: [],
    campaign_custom_field_values: active.flatMap(s => s.campaign_custom_field_values || []),
  }
}
